/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'print': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M26 32v-6h3.781c.604 0 1.125-.219 1.563-.656A2.17 2.17 0 0032 23.75V10.187c0-.604-.219-1.124-.656-1.562a2.134 2.134 0 00-1.563-.656H26V0H6v7.969H2.219c-.604 0-1.125.218-1.563.656A2.134 2.134 0 000 10.188V23.75c0 .625.219 1.156.656 1.594.438.437.959.656 1.563.656H6v6h20zM24 7.969H8v-6h16v6zM29.781 24H26v-7.031H6v7H2.219A.212.212 0 012 23.75V10.187a.212.212 0 01.219-.218H29.78a.212.212 0 01.219.219V23.75c0 .063-.02.12-.063.172a.192.192 0 01-.156.078zM26 13.969c.27 0 .505-.094.703-.281a.947.947 0 00.297-.72.961.961 0 00-.297-.702.961.961 0 00-.703-.297h-1a.961.961 0 00-.703.297.961.961 0 00-.297.703c0 .291.099.531.297.719a.988.988 0 00.703.28h1zM24 30H8V18.969h16V30z" _fill="#000" fill-rule="nonzero"/>'
  }
})
